import { render, staticRenderFns } from "./Temp.vue?vue&type=template&id=1c68d654&scoped=true"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"
import style0 from "./Temp.vue?vue&type=style&index=0&id=1c68d654&prod&lang=sass&scoped=true"
import style1 from "./Temp.vue?vue&type=style&index=1&id=1c68d654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c68d654",
  null
  
)

export default component.exports